import { render, staticRenderFns } from "./License.vue?vue&type=template&id=17784c57&scoped=true&"
import script from "./License.vue?vue&type=script&lang=ts&"
export * from "./License.vue?vue&type=script&lang=ts&"
import style0 from "./License.vue?vue&type=style&index=0&id=17784c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17784c57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/2/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VContainer,VFlex,VLayout,VRadio,VRadioGroup,VSnackbar,VSpacer,VTextField,VToolbar,VToolbarItems,VToolbarTitle})
